export default __webpack_public_path__ + "static/media/img2.20438ba3.png";